import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ButtonV2 } from '@zola/zola-ui';
import { deleteSeatingChart } from '../../../../actions/SeatingChartActions';

import './TableModal.less';

const DeleteChartModal = ({ onCancel, onDeleteChart, uuid }) => {
  const title = 'Are you sure you want to delete your seating chart?';
  const subtitle = 'All tables and objects will be permanently deleted. You’ll still be able to find all your guests’ info in your guest list.';

  return (
    <React.Fragment>
      <div className="modal-header">
        <h3>{title}</h3>
        <h4>{subtitle}</h4>
      </div>
      <div className="modal-body">
        <div className="modal__button-set">
          <ButtonV2 variant="secondary" role="button" onClick={() => onCancel()}>Cancel</ButtonV2>
          <ButtonV2 variant="tertiary" role="button" onClick={() => onDeleteChart(uuid)}>Delete Seating Chart</ButtonV2>
        </div>
      </div>
    </React.Fragment>
  );
};

DeleteChartModal.propTypes = {
  onDeleteChart: PropTypes.func,
  onCancel: PropTypes.func,
  uuid: PropTypes.string
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onCancel: () => ownProps.hideModalFn(),
  onDeleteChart: uuid => dispatch(deleteSeatingChart(uuid))
});

export default connect(null, mapDispatchToProps)(DeleteChartModal);



// WEBPACK FOOTER //
// ./src/components/manage/seatingchart/Modals/DeleteChart.jsx